import styled from 'styled-components';

export default styled.div`
  width: 30px;
  height: 20px;
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 2px;
  background: ${props => props.color};
  box-shadow: inset 0 -1px 2px rgba(0,0,0,0.2);
  cursor: pointer;
  &:hover {
    border: 1px solid rgba(255,255,255,0.3);
  }
`;


// WEBPACK FOOTER //
// ./src/components/common/styled-color-block.js